import React from "react";
import Text from "../../../../shared/components/Text";
import { formatMoney } from "nemuru-components";
import { getMinDownPaymentValueByAssetAmount } from "../utils/downPaymentCalculation";

export const HintDownPaymentImportLessThanMin = ({ autoPrice }) => (
  <>
    <Text>{"DOWN_PAYMENT_UNDER"}</Text>{" "}
    {formatMoney(getMinDownPaymentValueByAssetAmount(autoPrice), 0)}
  </>
);
